import { css } from 'styled-jsx/css';

export default css`
  .alert-box {
    background-color: rgba(149, 8, 16, 0.25);
    display: flex;
    flex-direction: column;
    border: 1px solid #fd0300;
    padding: 10px;
    margin: 1rem 0;
  }

  .alert-message {
    margin-left: 10px;
  }

  .alert-item {
    display: flex;
    margin-bottom: 16px;
  }

  .alert-item:nth-last-child(1) {
    margin-bottom: 0;
  }

  .attr {
    text-decoration: underline;
  }

  .value {
    text-decoration: underline;
  }

  button {
    width: auto;
    min-width: unset;
    display: inline;
    background: transparent;
    padding: 0;
    margin: 0;
    border: 0;
    color: white;
    text-decoration: underline;
  }
`;
